<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#000" d="M8 4H4.5v17.5h15V4H16M8.5 2.5h7v3h-7v-3zM7 9.5h10m-10 3h10"/>
</svg>
